import { usd } from './usd'
import { isPayUpFrontTerm } from '../utils/enrichSubscriptionUtils'
import { isValidCreditUnit } from './determineProductType'
import { legacyProducts } from './legacyProducts'

/**
 * Get the credit price of a product based on the unit price and unit size, and interval
 */
export const getLegacyProductCreditPrice = (product) => {
  if (!product || !product.unitPrice || !product.unitSize) return ''

  const interval = product.interval || product.recurring?.interval || 1
  const creditPrice = product.unitPrice / product.unitSize / interval

  return usd(creditPrice, 1)
}

/**
 * Get the credit price of a product based on the unit price and unit size, and interval
 */
export const getLegacyProductTotalPrice = (product) => {
  if (!product || !product.unitPrice) return ''

  const total = product.unitPrice * product.units

  return usd(total || 0, 1)
}

/**
 * Filters legacy products based on the state object and further filters for specific product units.
 * @param {object} state - state object with the following properties:
 *  - state.isSmallBusiness: Whether the customer is a small business
 *  - state.recurring?.term > 1: Whether the customer has an annual subscription
 *  - state.isPayUpFront: Whether the customer pays upfront
 * @returns {object} Object containing:
 *  - stateMatches: Array of products matching all criteria
 *  - otherProducts: Array of products not matching the criteria
 */
export const filterLegacyProductsByState = (state) => {
  const result = []

  legacyProducts.forEach((product) => {
    const id = product.id

    // Start with a true match
    let matches = true

    // Small Business Condition
    if (state?.isReserved && state.isSmallBusiness) {
      matches = matches && (id.includes('_smallbusiness_') || id.includes('_s_'))
    } else {
      matches = matches && !id.includes('_smallbusiness_') && !id.includes('_s_')
    }

    // Annual Subscription Condition
    if (state?.isReserved && state.recurring?.term > 1) {
      matches = matches && id.includes('_months12_')
    } else {
      matches = matches && !id.includes('_months12_')
    }

    // Pay Upfront Condition
    if (state?.isReserved && isPayUpFrontTerm(state.recurring)) {
      matches = matches && id.includes('_upfront_')
    } else {
      matches = matches && !id.includes('_upfront_')
    }

    // Unit Filtering Condition
    matches = matches && state?.isReserved && isValidCreditUnit(product)

    // Add product to appropriate array based on whether it matches all criteria
    if (matches) {
      result.push(product)
    }
  })

  return result
}
